export const delegationConstants = {
    CREATE_REQUEST: 'DELEGATION_CREATE_REQUEST',
    CREATE_SUCCESS: 'DELEGATION_CREATE_SUCCESS',
    CREATE_FAILURE: 'DELEGATION_CREATE_FAILURE',

    UPDATE_REQUEST: 'DELEGATION_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'DELEGATION_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'DELEGATION_UPDATE_FAILURE',

    REMOVE_REQUEST: 'DELEGATION_REMOVE_REQUEST',
    REMOVE_SUCCESS: 'DELEGATION_REMOVE_SUCCESS',
    REMOVE_FAILURE: 'DELEGATION_REMOVE_FAILURE',

    FETCH_REQUEST: 'DELEGATION_FETCH_REQUEST',
    FETCH_SUCCESS: 'DELEGATION_FETCH_SUCCESS',
    FETCH_FAILURE: 'DELEGATION_FETCH_FAILURE',

    GET_REQUEST: 'DELEGATION_GET_REQUEST',
    GET_SUCCESS: 'DELEGATION_GET_SUCCESS',
    GET_FAILURE: 'DELEGATION_GET_FAILURE',
};
